export default function clearCache() {
  localStorage.clear();

  document.cookie.split(";").forEach((cookie) => {
    document.cookie = cookie
      .replace(/^ +/, "")
      .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
  });

  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.getRegistrations().then(function (registrations) {
      for (let registration of registrations) {
        registration.unregister();
      }
    });
  }

  setTimeout(function () {
    const host = window.location.origin;
    const target = `${host}/#/login?_=` + new Date().getTime();
    window.location.href = target;
    window.location.reload();
  }, 1000);
}
